import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { NormalizedRequestApprovalDialog } from "@/components/approvalDialogs/RequestsApproval/NormalizedRequestApprovalDialog";
import { RequestOutreachStatus, useRequestOutreach } from "@/hooks/useRequestOutreach";
import SystemDialog from "@/ui/Popups/Dialog";
import type { ShiftRequest } from "@/utils/models";
import { RequestOutreachPopup } from "./RequestOutreachPopup";

/** Mounted only while open, so a list of cards never builds outreach nobody looks at. */
export const OutreachPopupContainer: FC<{ request: ShiftRequest; onClose: () => void }> = ({ request, onClose }) => {
	const { t } = useTranslation();
	const result = useRequestOutreach(request);
	const [reviewing, setReviewing] = useState(false);
	if (reviewing) return <NormalizedRequestApprovalDialog open request={request} onClose={onClose} />;
	if (result.status === RequestOutreachStatus.Failed) {
		return (
			<SystemDialog
				open
				onClose={onClose}
				title={t("request.outreach.title")}
				body={t("request.outreach.load.failed")}
				confirm={t("retry")}
				onConfirm={result.retry}
				dataTestId="request-outreach-load-failed"
			/>
		);
	}
	// While loading too: the popup opens once the request's weeks are in, rather than on an empty plan.
	if (result.status !== RequestOutreachStatus.Ready) return null;
	return <RequestOutreachPopup open onClose={onClose} onReview={() => setReviewing(true)} outreach={result.outreach} actions={result.actions} />;
};
